<template>
  <!-- Roles -->
  <detail-item
    v-if="!user.created_company"
    icon="mdi-account-check"
    name="Roles & Permissions"
    required
    :name-spacing="nameSpacing"
  >
    <q-field
      borderless
      :error="!!errors['roles']"
      :error-message="!!errors['roles'] ? errors['roles'][0] : null"
      bottom-slots
      color="black"
    >
      <div>
        <div class="q-mb-xs">
          {{ user.permissions.length }} selected permissions
        </div>
        <q-btn
          icon-right="mdi-chevron-right"
          label="Select Permissions"
          size="12px"
          :color="!!errors['roles'] ? 'red-7' : 'green'"
          @click="dialogOpen = true"
        />
      </div>
    </q-field>
  </detail-item>

  <content-dialog
    v-model="dialogOpen"
    fullscreen-mobile
    max-height="60vh"
    title="Account Permissions"
    close-icon="mdi-arrow-left"
    :loading="loading"
  >
    <div class="relative-position">
      <!-- Roles -->
      <q-item-label
        header
        class="text-bold"
      >
        Select Roles
      </q-item-label>
      <q-item-label
        caption
        class="q-px-md"
      >
        Select roles to prefill some permissions.
      </q-item-label>
      <checkbox-list
        class="full-width q-mt-sm"
        :list="availableRoles"
        :selected="user.roles"
        option-label="name"
        option-value="name"
        @selected="onSelectRole"
      >
        <template #default="scope">
          <q-item-label class="text-bold">
            {{ scope.name }}
          </q-item-label>
        </template>
      </checkbox-list>

      <q-separator
        inset
        class="q-my-md"
      />

      <!-- Permissions -->
      <q-item-label
        header
        class="text-bold"
      >
        Select Permissions
      </q-item-label>
      <q-item-label
        caption
        class="q-px-md q-mb-md"
      >
        Select the permissions for areas of the system that the staff member may access.
      </q-item-label>
      <q-list
        v-for="(list, key) in availablePermissions"
        :key="key"
      >
        <sticky-header class="q-mt-lg">
          {{ key || 'Uncategorised' }}
        </sticky-header>
        <q-item-wrapper
          v-for="(permission, pKey) in list"
          :key="key + pKey"
          :icon="permission.icon"
          :label="permission.readable_name || permission.name"
          :caption="permission.description"
          tag="label"
        >
          <template #after>
            <q-item-section side>
              <q-checkbox
                v-model="user.permissions"
                :val="permission.name"
              />
            </q-item-section>
          </template>
        </q-item-wrapper>
      </q-list>
      <div class="flex justify-end q-my-sm q-px-sm">
        <q-btn
          flat
          no-caps
          size="12px"
          label="Unselect All"
          color="orange-8"
          @click="unselectAll"
        />
        <q-btn
          flat
          no-caps
          size="12px"
          label="Select All"
          color="blue"
          class="q-ml-sm"
          @click="selectAll"
        />
      </div>
    </div>

    <template #bottom>
      <q-toolbar>
        <div>
          {{ user.permissions.length }} selected
        </div>
        <q-space />
        <q-btn
          v-close-popup
          label="Save"
          color="green"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    nameSpacing: {
      type: Number,
      required: true
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      dialogOpen: false,
      availableRoles: [],
      availablePermissions: {},
      defaults: {},
      loading: false
    }
  },
  watch: {
    'user.roles' (newVal, oldVal) {
      const addedVal = newVal.find(item => !oldVal.includes(item))
      if (addedVal) {
        for (const ele of this.defaults[addedVal]) {
          if (!this.user.permissions.includes(ele)) {
            this.user.permissions.push(ele)
          }
        }
      }
    }
  },
  methods: {
    onSelectRole (val) {
      this.user.roles = val
    },
    selectAll () {
      this.user.permissions = []
      for (const ele in this.availablePermissions) {
        this.user.permissions.push(...this.availablePermissions[ele].map(item => item.name))
      }
    },
    unselectAll () {
      this.user.permissions = []
    },
    async fetchPermissionData () {
      this.loading = true
      const { status, payload } = await this.$get('v1/business/company/users/permissions')
      this.loading = false
      if (status === 'success') {
        this.availableRoles = payload.roles
        this.availablePermissions = payload.permissions || {}
        this.defaults = payload.defaults
      }
    }
  },
  mounted () {
    this.fetchPermissionData()
  }
}
</script>
